import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { PLATFORMS } from '@constants';
import PaymentMobile from './PaymentMobile';
import PaymentDesktop from './PaymentDesktop';

const Payment = memo(({ platform, breakpoints }) => {
  if (platform !== PLATFORMS.GERMANY) return null;

  return breakpoints.xs || breakpoints.sm ? (
    <PaymentMobile />
  ) : (
    <PaymentDesktop />
  );
});

Payment.propTypes = {
  breakpoints: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  platform: PropTypes.string.isRequired,
};

Payment.displayName = 'Payment';

export default Payment;
